<template>
  <div>
    <div class="metadata-div-header">
      <div class="add-metadata-btn" @click="addField">
        <v-icon color="primary" size="16" start>md:add</v-icon>Add metadata
      </div>
    </div>
    <div v-for="(item, index) in metadata" :key="`${index}`" class="device-metadata">
      <v-text-field
        v-model.trim="item.key"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        hideDetails
        label="Key"
        name="device_key"
      ></v-text-field>
      <div class="metadata-value-col">
        <v-text-field
          :ref="
            el => {
              if (el) valueFieldRefs[index] = el;
            }
          "
          v-model.trim="item.value"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          hideDetails
          label="Value"
          name="device_value"
        ></v-text-field>
        <RfInsertUserTrait
          actionName="value"
          title="metadata value"
          :actions="item"
          :app="appsStore.app"
          :positionRef="valueFieldRefs[index]"
        />
      </div>
      <v-icon size="18" @click="onRemove(index)">md:clear</v-icon>
    </div>
  </div>
</template>

<script setup>
import { debounce } from "@/utils/debounce";
import { parseJsonSilently, stringifyJsonSilently } from "@/utils/JsonUtls";
import { ref, watch, onMounted } from "vue";
import RfInsertUserTrait from "@/components/RfPathCreate/RfRetentionActions/RfInsertUserTrait.vue";
import { useAppsStore } from "@/pinia/appsStore";

const props = defineProps({ actions: Object });

const appsStore = useAppsStore();
const metadata = ref([]);
const valueFieldRefs = ref([]);

const addField = () => metadata.value.push({ key: "", value: "" });
const onRemove = index => metadata.value.splice(index, 1);
const getMetadata = () =>
  Object.entries(parseJsonSilently(props.actions.rf_metadata)).map(([key, value]) => ({
    key,
    value,
  }));

watch(
  metadata,
  debounce(to => {
    const results = to
      .filter(item => !!item.key)
      .reduce((hash, { key, value }) => {
        hash[key] = value;
        return hash;
      }, {});
    props.actions.rf_metadata = stringifyJsonSilently(results);
  }, 100),
  { deep: true },
);

onMounted(() => (metadata.value = getMetadata()));
</script>

<style lang="scss" scoped>
.add-metadata-btn {
  display: inline-block;
  padding: 0 10px 5px;
  color: #3096ed;
  font-weight: bold;
  cursor: pointer;
}
.metadata-div-header {
  border-bottom: 1px solid #ccc;
  text-align: right;
  margin-bottom: 10px;
}
.device-metadata {
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  align-items: flex-start;

  > div.v-input {
    flex: 1;
    padding-right: 16px;
  }
}
.metadata-value-col {
  flex: 1;
  padding-right: 16px;
}
</style>
